"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _redirectEvents;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductInstallmentsStep = void 0;

var _services = require("../../services");

var _hooks = require("../../hooks");

var _utils = require("../../utils");

var _constants = require("../../constants");

var redirectEvents = (_redirectEvents = {}, _defineProperty(_redirectEvents, _constants.ProductTypes.HOME, _utils.redirectToHomeEquity), _defineProperty(_redirectEvents, _constants.ProductTypes.AUTO, _utils.redirectToAutoRefi), _redirectEvents);

var useProductInstallmentsStep = function useProductInstallmentsStep() {
  var _ref = (0, _hooks.useSimulator)(),
      closeSimulator = _ref.closeSimulator,
      intendedCredit = _ref.intendedCredit,
      setIntendedCredit = _ref.setIntendedCredit,
      productType = _ref.productType;

  var onRequestProposalClick = function onRequestProposalClick(product) {
    var redirectToProduct = redirectEvents[product];
    (0, _services.dispatchRequestProposalClickEvent)((0, _utils.getProductLabel)(product));
    redirectToProduct(intendedCredit);
  };

  return {
    intendedCredit: intendedCredit,
    productType: productType,
    setIntendedCredit: setIntendedCredit,
    closeSimulator: closeSimulator,
    onRequestProposalClick: onRequestProposalClick
  };
};

exports.useProductInstallmentsStep = useProductInstallmentsStep;